
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { SwapBridgeContainer } from './swap-bridge/SwapBridgeContainer';

export const BridgeView: React.FC = () => {
    return <SwapBridgeContainer initialMode="bridge" />;
};
